import React from 'react';
import { Paper, Box, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import BorderColorIcon from '@material-ui/icons/BorderColor';

const useStyles = makeStyles(theme => ({
  paperRoot: { height: '100%' },
  cardRoot: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  textGrey: {
    color: 'rgba(0, 0, 0, 0.5)',
  },
}));

const AnswerCard = ({ movement }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.paperRoot}>
      <Box className={classes.cardRoot} py={2} px={4}>
        <Box>
          <Box display="flex" alignItems="center" my={2}>
            <BorderColorIcon fontSize="small" />
            <Box ml={2} fontWeight={500}>
              Enviado para análise
            </Box>
          </Box>
          <Box mb={2}>
            <Divider />
          </Box>
        </Box>
        <Box mb={2} display="flex" alignItems="center">
          <Box fontWeight={700} fontSize={14}>
            Observação:
          </Box>
          <Box ml={2}>{movement.observacao}</Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default AnswerCard;
